import VideoPlayer from '@components/docViewer/CustomViewers/VideoViewer';
import {
  Typography,
  Button,
  Box,
  useMediaQuery,
  useTheme,
  Snackbar,
  Alert,
  ListItem,
  ListItemIcon,
  List,
  ListItemText,
  Divider
} from '@mui/material';
import LinkIcon from '@mui/icons-material/Link';
import PreviewDocViewer from './PreviewDocViewer';
import {memo, useState} from 'react';
import {
  LMS_TYPE,
  BASE_RECORD_ID,
  BASE_ROUTE,
  BASE_ROUTE_MODULE,
  BASE_UNIQUE_ID,
  LMS_MODULE_ID,
  PARAMS_KEY,
  MOVE_TO_TAB,
  LMS_IS_ADMIN,
  BASE_UNIQUE_TYPE
} from 'src/routes/BaseRoute';
import EncryptUtils from 'src/utils/EncryptUtils';
import FormConstants from '@shared/constants/FormConstants';
import {useLocation, useNavigate} from 'react-router-dom';
import React from 'react';
import TestPage from './OnlineTestPreview/IntroTestPreview';
import {enqueueSnackbar} from 'notistack';
import SnackBarConfig from '@components/snackbar/SnackbarConfig';
import ArticleIcon from '@mui/icons-material/Article'; // file
import MenuBookIcon from '@mui/icons-material/MenuBook'; // content
import AssignmentIcon from '@mui/icons-material/Assignment'; // assignment
import QuizIcon from '@mui/icons-material/Quiz'; // onlinetest
import ArrowRightIcon from '@mui/icons-material/ArrowRight'; // module
import moment from 'moment';
import {sanitizeHtml} from 'src/utils/htmlSanitizer';
const PreviewDoc = memo(
  ({selectedPreviewFiles}: any) => {
    //console.log('selectedPreviewFiles', selectedPreviewFiles);
    const theme = useTheme();
    const [openSnackbar, setOpenSnackbar] = useState(false);
    function useQuery() {
      const {search} = useLocation();
      return React.useMemo(() => new URLSearchParams(search), [search]);
    }
    const query = useQuery();
    const lmstype = EncryptUtils.getDecryptedData(location?.search, LMS_TYPE);
    const lmsisAdmin = EncryptUtils.getDecryptedData(
      location?.search,
      LMS_IS_ADMIN
    );
    const section = query.get('section');
    const subSection = query.get('subsection');
    const uniqueId = EncryptUtils.getDecryptedData(
      location?.search,
      BASE_RECORD_ID
    );
    const fileId = EncryptUtils.getDecryptedData(
      location?.search,
      BASE_UNIQUE_ID
    );
        const filetype=EncryptUtils.getDecryptedData(
          location?.search,
          BASE_UNIQUE_TYPE
        );
    const moduleId = EncryptUtils.getDecryptedData(
      location?.search,
      LMS_MODULE_ID
    );
    const navigate = useNavigate();
    const handleSnackbarClose = () => {
      setOpenSnackbar(false);
    };
    const onRoleChange = async () => {
      //console.log('onRoleChange1',uniqueId, fileId, moduleId,selectedPreviewFiles);
      if (selectedPreviewFiles?.remainingAttempts <= 0) {
        return setOpenSnackbar(true);
      }
      const paramsKey = EncryptUtils.setEncryptedParams({
        [BASE_RECORD_ID]: uniqueId,
        [LMS_TYPE]: lmstype,
        [LMS_IS_ADMIN]: lmsisAdmin,
        [MOVE_TO_TAB]: 'ModuleMain',
        [BASE_UNIQUE_ID]: selectedPreviewFiles?.id,
        [BASE_UNIQUE_TYPE]:selectedPreviewFiles?.type,
        [LMS_MODULE_ID]: selectedPreviewFiles?.module_id
      });
      navigate(
        `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/${FormConstants.MODULE.COURSE_CATALOG}/OnlineTest?${PARAMS_KEY}=${paramsKey}`,
        {
          state: {}
        }
      );
    };
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const extractIframeSrc = (iframeHtml: string): string | null => {
      const match = iframeHtml?.includes('embed');
      //console.log('srcmatch', match, iframeHtml);
      return match ? iframeHtml : null;
    };
    const isIframeCompatible = (src: string | null) => {
      //console.log('src', src);
      return (
        src?.startsWith('https://www.youtube.com') || src?.includes('embed')
      );
    };
    const getIconForType = (type: string) => {
      switch (type) {
        case 'file':
          return <ArticleIcon />;
        case 'link':
          return <LinkIcon />;
        case 'content':
          return <MenuBookIcon />;
        case 'assignment':
          return <AssignmentIcon />;
        case 'onlinetest':
          return <QuizIcon />;
        case 'module':
          return <ArrowRightIcon />;
        default:
          return <ArticleIcon />;
      }
    };
    console.log('selectedPreviewFiles', selectedPreviewFiles);

    switch (selectedPreviewFiles?.type) {
      case 'link':
        const parser = new DOMParser();
        const doc = parser.parseFromString(
          selectedPreviewFiles?.embedded_url,
          'text/html'
        );
        const iframeSrc = extractIframeSrc(selectedPreviewFiles?.embedded_url);
        // Query the iframe element to get its src and title attributes
        const iframeSrcName =
          doc.querySelector('iframe')?.getAttribute('src') ?? '';
        const titlename =
          doc.querySelector('iframe')?.getAttribute('title') ?? '';
        if (
          selectedPreviewFiles?.IsUnlocked === 1 &&
          (selectedPreviewFiles?.is_completed === 1 ||
            selectedPreviewFiles?.locked_linked_items.length === 0) &&
          lmsisAdmin === 'False'
        ) {
          //console.log('iframeSrcName', iframeSrcName, titlename);
          return iframeSrc && isIframeCompatible(iframeSrc) ? (
            // Render iframe directly
            <>
              <iframe
                src={iframeSrcName || selectedPreviewFiles?.embedded_url}
                title={titlename || selectedPreviewFiles?.name}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  border: 'none',
                  width: '100%',
                  height: '100%',
                  padding: '16px'
                }}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              />
            </>
          ) : (
            <>
              <Box>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                  <Box
                    sx={{
                      width: isMobile ? '80px' : '120px',
                      height: isMobile ? '80px' : '120px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      bgcolor: 'primary.light',
                      borderRadius: '50%',
                      mb: 3
                    }}>
                    <LinkIcon
                      sx={{
                        fontSize: isMobile ? '40px' : '60px',
                        color: 'primary.main'
                      }}
                    />
                  </Box>
                </Box>

                {/* Text Section */}
                <Typography
                  variant={isMobile ? 'body1' : 'h6'}
                  textAlign="center"
                  color="text.secondary"
                  sx={{maxWidth: '400px', mb: 3}}>
                  Only embedded links are directly viewable here. Click below to
                  continue.
                </Typography>

                {/* Button Section */}
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                  <Button
                    variant="contained"
                    color="primary"
                    endIcon={<LinkIcon />}
                    sx={{
                      px: isMobile ? 2 : 4,
                      py: isMobile ? 1 : 1.5,
                      fontSize: isMobile ? '0.875rem' : '1rem',
                      textTransform: 'none'
                    }}
                    onClick={() =>
                      window.open(
                        `${selectedPreviewFiles.embedded_url}`,
                        '_blank'
                      )
                    }>
                    View in new tab
                  </Button>
                </Box>
              </Box>
            </>
          );
        } else if (lmsisAdmin === 'False') {
          const itemLength =
            selectedPreviewFiles?.locked_linked_items?.length || 0;
          return (
            <Box>
              <Typography variant="h6" textAlign="center">
                Complete the below items to unlock
              </Typography>
              <List>
                {selectedPreviewFiles?.locked_linked_items &&
                  selectedPreviewFiles?.locked_linked_items.length > 0 &&
                  selectedPreviewFiles?.locked_linked_items.map(
                    (
                      item: {
                        id: React.Key | null | undefined;
                        type: string;
                        item_name: any;
                      },
                      index: number
                    ) => (
                      <React.Fragment key={item.id}>
                        <ListItem>
                          <ListItemIcon>
                            {getIconForType(item.type)}
                          </ListItemIcon>
                          <ListItemText primary={item.item_name} />
                        </ListItem>
                        {index < itemLength - 1 && <Divider />}
                      </React.Fragment>
                    )
                  )}
                {itemLength === 0 && (
                  <ListItem>
                    <ListItemText
                      primary={`The entity will be unlocked on: ${moment(
                        selectedPreviewFiles.lockDate
                      ).format('DD/MM/YYYY')}`}
                    />
                  </ListItem>
                )}
              </List>
            </Box>
          );
        } else {
          return iframeSrc && isIframeCompatible(iframeSrc) ? (
            // Render iframe directly
            <>
              <iframe
                src={iframeSrcName || selectedPreviewFiles?.embedded_url}
                title={titlename || selectedPreviewFiles?.name}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  border: 'none',
                  width: '100%',
                  height: '100%',
                  padding: '16px'
                }}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              />
            </>
          ) : (
            <>
              <Box>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                  <Box
                    sx={{
                      width: isMobile ? '80px' : '120px',
                      height: isMobile ? '80px' : '120px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      bgcolor: 'primary.light',
                      borderRadius: '50%',
                      mb: 3
                    }}>
                    <LinkIcon
                      sx={{
                        fontSize: isMobile ? '40px' : '60px',
                        color: 'primary.main'
                      }}
                    />
                  </Box>
                </Box>

                {/* Text Section */}
                <Typography
                  variant={isMobile ? 'body1' : 'h6'}
                  textAlign="center"
                  color="text.secondary"
                  sx={{maxWidth: '400px', mb: 3}}>
                  Only embedded links are directly viewable here. Click below to
                  continue.
                </Typography>

                {/* Button Section */}
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                  <Button
                    variant="contained"
                    color="primary"
                    endIcon={<LinkIcon />}
                    sx={{
                      px: isMobile ? 2 : 4,
                      py: isMobile ? 1 : 1.5,
                      fontSize: isMobile ? '0.875rem' : '1rem',
                      textTransform: 'none'
                    }}
                    onClick={() =>
                      window.open(
                        `${selectedPreviewFiles.embedded_url}`,
                        '_blank'
                      )
                    }>
                    View in new tab
                  </Button>
                </Box>
              </Box>
            </>
          );
        }

      case 'file':
        if (
          selectedPreviewFiles?.IsUnlocked === 1 &&
          (selectedPreviewFiles?.is_completed === 1 ||
            selectedPreviewFiles?.locked_linked_items.length === 0) &&
          lmsisAdmin === 'False'
        ) {
          if (selectedPreviewFiles?.blob_file_extension === 'mp4') {
            return <VideoPlayer docData={selectedPreviewFiles} />;
          }
          return <PreviewDocViewer docData={selectedPreviewFiles} />;
        } else if (lmsisAdmin === 'False') {
          const itemLength =
            selectedPreviewFiles?.locked_linked_items?.length || 0;
          return (
            <Box>
              <Typography variant="h6" textAlign="center">
                Complete the below items to unlock
              </Typography>
              <List>
                {selectedPreviewFiles?.locked_linked_items &&
                  selectedPreviewFiles?.locked_linked_items.length > 0 &&
                  selectedPreviewFiles?.locked_linked_items.map(
                    (
                      item: {
                        id: React.Key | null | undefined;
                        type: string;
                        item_name: any;
                      },
                      index: number
                    ) => (
                      <React.Fragment key={item.id}>
                        <ListItem>
                          <ListItemIcon>
                            {getIconForType(item.type)}
                          </ListItemIcon>
                          <ListItemText primary={item.item_name} />
                        </ListItem>
                        {index < itemLength - 1 && <Divider />}
                      </React.Fragment>
                    )
                  )}
                {itemLength === 0 && (
                  <ListItem>
                    <ListItemText
                      primary={`The entity will be unlocked on: ${moment(
                        selectedPreviewFiles.lockDate
                      ).format('DD/MM/YYYY')}`}
                    />
                  </ListItem>
                )}
              </List>
            </Box>
          );
        } else {
          if (selectedPreviewFiles?.blob_file_extension === 'mp4') {
            return <VideoPlayer docData={selectedPreviewFiles} />;
          }
          return <PreviewDocViewer docData={selectedPreviewFiles} />;
        }

      case 'content':
        if (
          selectedPreviewFiles?.IsUnlocked === 1 &&
          (selectedPreviewFiles?.is_completed === 1 ||
            selectedPreviewFiles?.locked_linked_items.length === 0) &&
          lmsisAdmin === 'False'
        ) {
          return (
            <div
              dangerouslySetInnerHTML={{__html: sanitizeHtml(selectedPreviewFiles?.content)}}
              style={{
                border: '1px solid #ccc',
                padding: '10px',
                position: 'relative',
                overflowY: 'auto',
                height: '100%',
                width: '100%'
              }}></div>
          );
        } else if (lmsisAdmin === 'False') {
          const itemLength =
            selectedPreviewFiles?.locked_linked_items?.length || 0;
          return (
            <Box>
              <Typography variant="h6" textAlign="center">
                Complete the below items to unlock
              </Typography>
              <List>
                {selectedPreviewFiles?.locked_linked_items &&
                  selectedPreviewFiles?.locked_linked_items.length > 0 &&
                  selectedPreviewFiles?.locked_linked_items.map(
                    (
                      item: {
                        id: React.Key | null | undefined;
                        type: string;
                        item_name: any;
                      },
                      index: number
                    ) => (
                      <React.Fragment key={item.id}>
                        <ListItem>
                          <ListItemIcon>
                            {getIconForType(item.type)}
                          </ListItemIcon>
                          <ListItemText primary={item.item_name} />
                        </ListItem>
                        {index < itemLength - 1 && <Divider />}
                      </React.Fragment>
                    )
                  )}
                {itemLength === 0 && (
                  <ListItem>
                    <ListItemText
                      primary={`The entity will be unlocked on: ${moment(
                        selectedPreviewFiles.lockDate
                      ).format('DD/MM/YYYY')}`}
                    />
                  </ListItem>
                )}
              </List>
            </Box>
          );
        } else {
          return (
            <div
              dangerouslySetInnerHTML={{__html: sanitizeHtml(selectedPreviewFiles?.content)}}
              style={{
                border: '1px solid #ccc',
                padding: '10px',
                position: 'relative',
                overflowY: 'auto',
                height: '100%',
                width: '100%'
              }}></div>
          );
        }

      case 'assignment':
        if (
          selectedPreviewFiles?.IsUnlocked === 1 &&
          (selectedPreviewFiles?.is_completed === 1 ||
            selectedPreviewFiles?.locked_linked_items.length === 0) &&
          lmsisAdmin === 'False'
        ) {
          return (
            <Box sx={{width: '100%', height: '100%'}}>
              <Box sx={{display: 'grid', rowGap: 1.5, p: 1}}>
                <Box sx={{display: 'flex', columnGap: 1}}>
                  <Typography sx={{fontWeight: '600'}}>Type:</Typography>
                  <Typography>Assignment</Typography>
                </Box>
                {selectedPreviewFiles?.maximum_marks && (
                  <Box sx={{display: 'flex', columnGap: 1}}>
                    <Typography sx={{fontWeight: '600'}}>Max Marks:</Typography>
                    <Typography>
                      {selectedPreviewFiles?.maximum_marks}
                    </Typography>
                  </Box>
                )}
                {selectedPreviewFiles?.SubmissionType && (
                  <Box sx={{display: 'flex', columnGap: 1}}>
                    <Typography sx={{fontWeight: '600'}}>
                      Submission Type:
                    </Typography>
                    <Typography>
                      {selectedPreviewFiles?.SubmissionType}
                    </Typography>
                  </Box>
                )}
              </Box>
            </Box>
          );
        } else if (lmsisAdmin === 'False') {
          const itemLength =
            selectedPreviewFiles?.locked_linked_items?.length || 0;
          return (
            <Box>
              <Typography variant="h6" textAlign="center">
                Complete the below items to unlock
              </Typography>
              <List>
                {selectedPreviewFiles?.locked_linked_items &&
                  selectedPreviewFiles?.locked_linked_items.length > 0 &&
                  selectedPreviewFiles?.locked_linked_items.map(
                    (
                      item: {
                        id: React.Key | null | undefined;
                        type: string;
                        item_name: any;
                      },
                      index: number
                    ) => (
                      <React.Fragment key={item.id}>
                        <ListItem>
                          <ListItemIcon>
                            {getIconForType(item.type)}
                          </ListItemIcon>
                          <ListItemText primary={item.item_name} />
                        </ListItem>
                        {index < itemLength - 1 && <Divider />}
                      </React.Fragment>
                    )
                  )}
                {itemLength === 0 && (
                  <ListItem>
                    <ListItemText
                      primary={`The entity will be unlocked on: ${moment(
                        selectedPreviewFiles.lockDate
                      ).format('DD/MM/YYYY')}`}
                    />
                  </ListItem>
                )}
              </List>
            </Box>
          );
        } else {
          return (
            <Box sx={{width: '100%', height: '100%'}}>
              <Box sx={{display: 'grid', rowGap: 1.5, p: 1}}>
                <Box sx={{display: 'flex', columnGap: 1}}>
                  <Typography sx={{fontWeight: '600'}}>Type:</Typography>
                  <Typography>Assignment</Typography>
                </Box>
                {selectedPreviewFiles?.maximum_marks && (
                  <Box sx={{display: 'flex', columnGap: 1}}>
                    <Typography sx={{fontWeight: '600'}}>Max Marks:</Typography>
                    <Typography>
                      {selectedPreviewFiles?.maximum_marks}
                    </Typography>
                  </Box>
                )}
                {selectedPreviewFiles?.SubmissionType && (
                  <Box sx={{display: 'flex', columnGap: 1}}>
                    <Typography sx={{fontWeight: '600'}}>
                      Submission Type:
                    </Typography>
                    <Typography>
                      {selectedPreviewFiles?.SubmissionType}
                    </Typography>
                  </Box>
                )}
              </Box>
            </Box>
          );
        }

      case 'onlinetest':
        if (
          selectedPreviewFiles?.IsUnlocked === 1 &&
          (selectedPreviewFiles?.is_completed === 1 ||
            selectedPreviewFiles?.locked_linked_items.length === 0) &&
          lmsisAdmin === 'False'
        ) {
          return (
            <Box
              sx={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flex: 1,
                flexDirection: 'column',
                justifyContent: 'space-between'
              }}>
              <Box
                sx={{
                  display: 'flex',
                  rowGap: 1.5,
                  p: 1,
                  flexDirection: 'column'
                }}>
                <Box sx={{display: 'flex', columnGap: 1}}>
                  <Typography sx={{fontWeight: '600'}}>Type:</Typography>
                  <Typography>Online</Typography>
                </Box>
                {selectedPreviewFiles?.allowed_no_of_reattempts_ids && (
                  <Box sx={{display: 'flex', columnGap: 1}}>
                    <Typography sx={{fontWeight: '600'}}>
                      Allowed Attempts:
                    </Typography>
                    <Typography>
                      {selectedPreviewFiles?.allowed_no_of_reattempts_ids}
                    </Typography>
                  </Box>
                )}
                {selectedPreviewFiles?.remainingAttempts !== undefined && (
                  <Box sx={{display: 'flex', columnGap: 1}}>
                    <Typography sx={{fontWeight: '600'}}>
                      Remaining Attempts:
                    </Typography>
                    <Typography>
                      {selectedPreviewFiles?.remainingAttempts}
                    </Typography>
                  </Box>
                )}
                {selectedPreviewFiles?.allowed_reattempt_type_ids && (
                  <Box sx={{display: 'flex', columnGap: 1}}>
                    <Typography sx={{fontWeight: '600'}}>
                      Allow Reattempts Until:
                    </Typography>
                    <Typography>
                      {selectedPreviewFiles?.allowed_reattempt_type_ids}
                    </Typography>
                  </Box>
                )}
                {selectedPreviewFiles?.pass_percentage && (
                  <Box sx={{display: 'flex', columnGap: 1}}>
                    <Typography sx={{fontWeight: '600'}}>
                      Pass Percentage:
                    </Typography>
                    <Typography>
                      {selectedPreviewFiles?.pass_percentage}
                    </Typography>
                  </Box>
                )}
                <Box sx={{display: 'flex', columnGap: 1}}>
                  <Typography sx={{fontWeight: '600'}}>Show Marks:</Typography>
                  <Typography>
                    {selectedPreviewFiles?.assessment_show_marks_type_ids
                      ? 'Yes'
                      : 'No'}
                  </Typography>
                </Box>
                {selectedPreviewFiles?.assessment_show_marks_type_ids && (
                  <Box sx={{display: 'flex', columnGap: 1}}>
                    <Typography sx={{fontWeight: '600'}}>
                      Show Correct Answers To Learner:
                    </Typography>
                    <Typography>
                      {selectedPreviewFiles?.assessment_show_marks_type_ids}
                    </Typography>
                  </Box>
                )}
                {selectedPreviewFiles?.description && (
                  <Box sx={{display: 'flex', columnGap: 1}}>
                    <Typography sx={{fontWeight: '600'}}>
                      Description:
                    </Typography>
                    <Typography>{selectedPreviewFiles?.description}</Typography>
                  </Box>
                )}
              </Box>
              <Box sx={{display: 'flex', justifyContent: 'flex-end'}}>
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  onClick={() => onRoleChange()}>
                  Preview Test
                </Button>
              </Box>
              <Snackbar
                open={openSnackbar}
                autoHideDuration={3000}
                onClose={handleSnackbarClose}
                anchorOrigin={{vertical: 'top', horizontal: 'center'}}>
                <Alert
                  onClose={handleSnackbarClose}
                  severity="warning"
                  sx={{width: '40vw'}}>
                  There are NO attempts for the test.
                </Alert>
              </Snackbar>
            </Box>
          );
        } else if (lmsisAdmin === 'False') {
          const itemLength =
            selectedPreviewFiles?.locked_linked_items?.length || 0;
          return (
            <Box>
              <Typography variant="h6" textAlign="center">
                Complete the below items to unlock
              </Typography>
              <List>
                {selectedPreviewFiles?.locked_linked_items &&
                  selectedPreviewFiles?.locked_linked_items.length > 0 &&
                  selectedPreviewFiles?.locked_linked_items.map(
                    (
                      item: {
                        id: React.Key | null | undefined;
                        type: string;
                        item_name: any;
                      },
                      index: number
                    ) => (
                      <React.Fragment key={item.id}>
                        <ListItem>
                          <ListItemIcon>
                            {getIconForType(item.type)}
                          </ListItemIcon>
                          <ListItemText primary={item.item_name} />
                        </ListItem>
                        {index < itemLength - 1 && <Divider />}
                      </React.Fragment>
                    )
                  )}
                {itemLength === 0 && (
                  <ListItem>
                    <ListItemText
                      primary={`The entity will be unlocked on: ${moment(
                        selectedPreviewFiles.lockDate
                      ).format('DD/MM/YYYY')}`}
                    />
                  </ListItem>
                )}
              </List>
            </Box>
          );
        } else {
          return (
            <Box
              sx={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flex: 1,
                flexDirection: 'column',
                justifyContent: 'space-between'
              }}>
              <Box
                sx={{
                  display: 'flex',
                  rowGap: 1.5,
                  p: 1,
                  flexDirection: 'column'
                }}>
                <Box sx={{display: 'flex', columnGap: 1}}>
                  <Typography sx={{fontWeight: '600'}}>Type:</Typography>
                  <Typography>Online</Typography>
                </Box>
                {selectedPreviewFiles?.allowed_no_of_reattempts_ids && (
                  <Box sx={{display: 'flex', columnGap: 1}}>
                    <Typography sx={{fontWeight: '600'}}>
                      Allowed Attempts:
                    </Typography>
                    <Typography>
                      {selectedPreviewFiles?.allowed_no_of_reattempts_ids}
                    </Typography>
                  </Box>
                )}
                {selectedPreviewFiles?.remainingAttempts !== undefined && (
                  <Box sx={{display: 'flex', columnGap: 1}}>
                    <Typography sx={{fontWeight: '600'}}>
                      Remaining Attempts:
                    </Typography>
                    <Typography>
                      {selectedPreviewFiles?.remainingAttempts}
                    </Typography>
                  </Box>
                )}
                {selectedPreviewFiles?.allowed_reattempt_type_ids && (
                  <Box sx={{display: 'flex', columnGap: 1}}>
                    <Typography sx={{fontWeight: '600'}}>
                      Allow Reattempts Until:
                    </Typography>
                    <Typography>
                      {selectedPreviewFiles?.allowed_reattempt_type_ids}
                    </Typography>
                  </Box>
                )}
                {selectedPreviewFiles?.pass_percentage && (
                  <Box sx={{display: 'flex', columnGap: 1}}>
                    <Typography sx={{fontWeight: '600'}}>
                      Pass Percentage:
                    </Typography>
                    <Typography>
                      {selectedPreviewFiles?.pass_percentage}
                    </Typography>
                  </Box>
                )}
                <Box sx={{display: 'flex', columnGap: 1}}>
                  <Typography sx={{fontWeight: '600'}}>Show Marks:</Typography>
                  <Typography>
                    {selectedPreviewFiles?.assessment_show_marks_type_ids
                      ? 'Yes'
                      : 'No'}
                  </Typography>
                </Box>
                {selectedPreviewFiles?.assessment_show_marks_type_ids && (
                  <Box sx={{display: 'flex', columnGap: 1}}>
                    <Typography sx={{fontWeight: '600'}}>
                      Show Correct Answers To Learner:
                    </Typography>
                    <Typography>
                      {selectedPreviewFiles?.assessment_show_marks_type_ids}
                    </Typography>
                  </Box>
                )}
                {selectedPreviewFiles?.description && (
                  <Box sx={{display: 'flex', columnGap: 1}}>
                    <Typography sx={{fontWeight: '600'}}>
                      Description:
                    </Typography>
                    <Typography>{selectedPreviewFiles?.description}</Typography>
                  </Box>
                )}
              </Box>
              <Box sx={{display: 'flex', justifyContent: 'flex-end'}}>
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  onClick={() => onRoleChange()}>
                  Preview Test
                </Button>
              </Box>
              <Snackbar
                open={openSnackbar}
                autoHideDuration={3000}
                onClose={handleSnackbarClose}
                anchorOrigin={{vertical: 'top', horizontal: 'center'}}>
                <Alert
                  onClose={handleSnackbarClose}
                  severity="warning"
                  sx={{width: '40vw'}}>
                  There are NO attempts for the test.
                </Alert>
              </Snackbar>
            </Box>
          );
        }
      case 'module':
        const itemLength = selectedPreviewFiles?.lockData?.length || 0;
        return (
          <Box>
            <Typography variant="h6" textAlign="center">
              Complete the below items to unlock
            </Typography>
            <List>
              {selectedPreviewFiles?.lockData &&
                selectedPreviewFiles?.lockData.length > 0 &&
                selectedPreviewFiles?.lockData.map(
                  (
                    item: {
                      id: React.Key | null | undefined;
                      type: string;
                      item_name: any;
                    },
                    index: number
                  ) => (
                    <React.Fragment key={item.id}>
                      <ListItem>
                        <ListItemIcon>{getIconForType(item.type)}</ListItemIcon>
                        <ListItemText primary={item.item_name} />
                      </ListItem>
                      {index < itemLength - 1 && <Divider />}
                    </React.Fragment>
                  )
                )}
              {itemLength === 0 && (
                <ListItem>
                  <ListItemText
                    primary={`The entity will be unlocked on: ${moment(
                      selectedPreviewFiles.lockDate
                    ).format('DD/MM/YYYY')}`}
                  />
                </ListItem>
              )}
            </List>
          </Box>
        );
      default:
        return (
          <div>
            <p>Unknown type</p>
          </div>
        );
    }
  },
  (prevProps, nextProps) => {
    // //console.log(
    //   'propesss',
    //   Number(prevProps.selectedPreviewFiles?.id) ===
    //     Number(nextProps.selectedPreviewFiles?.id),
    //   prevProps,
    //   nextProps
    // );
    return (
      Number(prevProps.selectedPreviewFiles?.id) ===
      Number(nextProps.selectedPreviewFiles?.id) && prevProps.selectedPreviewFiles?.type===nextProps.selectedPreviewFiles?.type
    );
  }
);
export default PreviewDoc;
